import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import MetricTableModel from "../../models/metric-table";

export default class MetricTableRepository extends BaseRepository {
  static modelClass = MetricTableModel;
  modelName = "metric-table";

  async findRecord(params) {
    return await super.findRecord(1, {
      urlPath: MetricTableModel.urlPath + "?" + qs.stringify(params),
    });
  }
}
